import WithCard from "./withCard.jsx";

export default WithCard;



// WEBPACK FOOTER //
// ./src/components/common/withCard/index.js